'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.pipeline.config.preconditions.service', [
  require('./preconditionTypeConfig.provider.js').name,
])
  .factory('preconditionTypeService', function (preconditionTypeConfig) {

    function listPreconditionTypes() {
      return preconditionTypeConfig.listPreconditionTypes();
    }

    function getPreconditionType(key) {
      return _.find(preconditionTypeConfig.listPreconditionTypes(), { key: key });
    }

    return {
      listPreconditionTypes: listPreconditionTypes,
      getPreconditionType: getPreconditionType
    };

  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/preconditions/preconditionType.service.js